module.exports = __webpack_public_path__ + "img/1566748448.a89cf5a6.jpg";